import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { UI_STRINGS, resolveUiString } from '../utils/uiStrings';

const STORAGE_KEY = 'lms-ui-language';

const LanguageContext = createContext(null);

export const SUPPORTED_UI_LANGS = [
  { id: 'en', short: 'EN' },
  { id: 'si', short: 'සිං' },
  { id: 'ta', short: 'தமிழ்' },
];

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (v === 'si' || v === 'ta' || v === 'en') return v;
    } catch {
      /* ignore */
    }
    return 'en';
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, language);
    } catch {
      /* ignore */
    }
    document.documentElement.lang =
      language === 'si' ? 'si' : language === 'ta' ? 'ta' : 'en';
  }, [language]);

  const setLanguage = (lang) => {
    if (lang === 'en' || lang === 'si' || lang === 'ta') {
      setLanguageState(lang);
    }
  };

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      t: (key, params) => resolveUiString(UI_STRINGS, language, key, params),
    }),
    [language],
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      language: 'en',
      setLanguage: () => {},
      t: (key, params) => resolveUiString(UI_STRINGS, 'en', key, params),
    };
  }
  return ctx;
}
